
export const dateToNum = (d) => {
	// Convert date "26/06/2016" to 20160626
	d = d.split("/");
	var m = d[1].length < 2 ? `0${d[1]}` : d[1];
	var day = d[0].length < 2 ? `0${d[0]}` : d[0];
	return Number(d[2]+m+day);
};

